<template>
    <SignUpResult />
</template>

<script>
import SignUpResult from "@/components/SignUpResult.vue";

export default {
    name: 'SignUpResultView',
    components: {
        SignUpResult
    }
}
</script>
